import { LeerkrachtI } from '@models/leerkracht.model';

export interface LeerkrachtenStateModel {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  leerkrachten: any[] | LeerkrachtI[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
  selectedLeerkrachtId: string;
}

export const LeerkrachtenInitialState = {
  leerkrachten: [] as LeerkrachtI[],
  loading: false,
  error: null,
  loaded: false,
  selectedLeerkrachtId: '',
};
